import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Events/GlobalFreightSummit/components/SectionVideo/SectionVideo.module.scss';

const cn = classNames.bind(styles);

const SectionVideo = (): ReactElement => {
  return (
    <section className={cn('video')}>
      <div className={cn('container')}>
        <div className={cn('video__content')}>
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'VideoObject',
                name: 'Global Freight Summit 2024',
                description:
                  'Global Freight Summit 2024 is your chance to connect with over 5,000 industry leaders from 155+ countries across diverse sectors. Gain actionable insights on digitisation, sustainability, and building resilient trade routes.',
                thumbnailUrl: [
                  'https://www.df-alliance.com/images/pages/Events/GlobalFreightSummit/gfs-2024-player-bg.png',
                ],
                uploadDate: '2024-03-01T08:00:00+08:00',
                duration: 'PT00H01M41S',
                contentUrl: 'https://cvent-production-cs-creative-prod-us-east-1.s3.amazonaws.com/Media/DPWUAE001/K3N6769DY5P/GFS2023_HIGHLIGHT_DAY1.mp4',
              }),
            }}
          />
          <video
            className={cn('video__player')}
            poster="/images/pages/Events/GlobalFreightSummit/gfs-2024-player-bg.png"
            controls
          >
            <source src="https://cvent-production-cs-creative-prod-us-east-1.s3.amazonaws.com/Media/DPWUAE001/K3N6769DY5P/GFS2023_HIGHLIGHT_DAY1.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </section>
  );
};

export default SectionVideo;